const graphics = {
    title: String("Graphics"),
    graphicsManagerTitle: String("Graphic management"),
    batteryChartTitle: String("Battery voltage (V)"),
    temperatureChartTitle: String("Temperature (ºC) and relative humidity (%)"),
    leafHumidityChartTitle: String("Leaf moisture (mV)"),
    rainmeterChartTitle: String("Rainfall (L)"),
    soilMoistureChartTitle: String("Soil moisture probes"),
    rainAndFlowChartTitle: String("Rainfall (L) and Flowmeter (L/m3)"),
    flowmeterChartTitle: String("Flowmeter (L/m3)"),
    selectorPlaceholder: String("Module list"),
    generateChartsButton: String("Generate graphics"),
    fetchingDataButton: String("Generating"),
    fetchingDataMessage: String("The graphics are generating. Hang on a minute"),
    largeDataAdviseMessage: String("For long periods this process may take several minutes"),
    noModulesAvailable: String("There are no modules available"),
    fetchingNotFoundMessage: String("No data could be found for the date range provided"),
    noDataSelected: String("No data selected"),
    accumulatedRainLabel: String("Accumulated rainfall"),
    accumulatedFlowLabel: String("Accumulated irrigation"),
    generateReport: String("Generate report"),
    temperatureDropdownItem: String("Temperature and relative humidity"),
    leafHumidityDropdownItem: String("Leaf moisture"),
    soilMoistureDropdownItem: String("Soil moisture probes"),
    rainAndFlowDropdownItem: String("Rainfall and Flowmeter"),
    dropdownAnalysisOption: String("Irrigation analysis"),
    download: String("Download"),
    downloadDataset: String("Download data"),
    moduleName: String("Module Name"),
    moduleId: String("Module Code"),
    modulePeriod: String("Period"),
    //Modal
    generatingReport: String("Generating report"),
    genTempHumChartMsg: String("Exporting temperature and HR chart"),
    genLeafHumChartMsg: String("Exporting leaf moisture chart"),
    genSoilChartMsg: String("Exporting soil moisture chart"),
    genRainFlowChartMsg: String("Exporting rainmeter and flowmeter chart"),
    genPDFMsg: String("Generating PDF report"),
    genDownloadingPDFMsg: String("Downloading report"),
    legendWaterNotAvailable:    String('Water not available'),
    legendWaterAvailable:       String('Water available'),
    legendWaterEasyAvailable:   String('Water easily available'),
}

export default graphics;
